import React, { useState, useEffect, useRef } from "react";
import { GoPeople, GoSidebarExpand, GoSidebarCollapse } from "react-icons/go";
import { AiOutlineProduct } from "react-icons/ai";
import { TbBrandDatabricks } from "react-icons/tb";
import { SiAlwaysdata } from "react-icons/si";
import { TbPackageImport } from "react-icons/tb";
import { TfiImport } from "react-icons/tfi";
import { ImUpload } from "react-icons/im";
import { MdOutlinePeopleAlt } from "react-icons/md";
import { LuWorkflow } from "react-icons/lu";
import {
  FaChartBar,
  FaTable,
  FaDatabase,
  FaProjectDiagram,
  FaUpload,
  FaCogs,
  FaUserFriends,
  FaBell,
  FaComments,
  FaCog,
  FaQuestionCircle,
  FaRegFileAlt,
  FaEllipsisH,
  FaUser,
  FaSlidersH,
  FaEye,
  FaTasks,
  FaGem,
  FaSignOutAlt,
  FaNetworkWired,
} from "react-icons/fa";
import { FaPlus } from "react-icons/fa6";
import { RiLoginCircleFill } from "react-icons/ri";
import { useNavigate } from "react-router-dom";
import { PiDatabaseFill } from "react-icons/pi";

const navItems = [
    {
    icon: (
      <span className="sidebar-icon-circle">
        <FaPlus style={{ color: '#fbfbfb' }} />
      </span>
    ),
    label: "New Project"
  },
  { icon: <AiOutlineProduct style={{ color: 'var(--primary-color)' }} />, label: "Projects" },
  { icon: <PiDatabaseFill style={{ color: 'var(--primary-color)' }} />, label: "Datasets" },
  { icon: <ImUpload style={{ color: 'var(--primary-color)' }} />, label: "Upload Data" },
];

const analysisItems = [
  { icon: <FaProjectDiagram style={{ color: 'var(--primary-color)' }} />, label: "Workflows" },
  { icon: <SiAlwaysdata style={{ color: 'var(--primary-color)' }} />, label: "Models" },
];

const accountItems = [
  { icon: <MdOutlinePeopleAlt style={{ color: 'var(--primary-color)' }} />, label: "Team" },
  { icon: <FaCogs style={{ color: 'var(--primary-color)' }} />, label: "Project Settings" },
];

const Sidebar = ({
  isSidebarVisible,
  setIsSidebarVisible,
  isAuthenticated,
  user, // Add user prop
  username, // <-- receive username from Firestore as prop
  projects,
  currentProject,
  setShowProjectModal,
  handleSelectProject,
  handleDeleteProject,
  setShowLoginModal,
  onLogout, // Add logout handler
}) => {
  const navigate = useNavigate();
  const [showUserMenu, setShowUserMenu] = useState(false);
  const menuRef = useRef(null);

  // Close menu when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setShowUserMenu(false);
      }
    };

    if (showUserMenu) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showUserMenu]);

  const userMenuItems = [
    { label: "Settings" },
    { label: "Upgrade plan" },
    { label: "Learn more" },
  ];

  const handleUserMenuClick = (e) => {
    e.stopPropagation();
    setShowUserMenu(!showUserMenu);
  };

  const handleLogoutClick = () => {
    setShowUserMenu(false);
    onLogout();
  };

  const handleMenuItemClick = (item) => {
    console.log(`Clicked ${item.label}`);
    setShowUserMenu(false);
    if (item.label === "Settings") {
      window.location.href = "/settings";
    }
    // Add navigation logic here for other items
  };

  // Helper: close sidebar on mobile
  const closeSidebarIfMobile = () => {
    if (window.innerWidth <= 768) {
      setIsSidebarVisible(false);
    }
  };

  const handleNavItemClick = (item) => {
    closeSidebarIfMobile();
    // Add your navigation logic here if needed
  };

  const handleSignInClick = (e) => {
    closeSidebarIfMobile();
    if (typeof setShowLoginModal === 'function') {
      setShowLoginModal(true);
    } else if (typeof navigate === 'function') {
      navigate('/login');
    }
  };

  return (
    <>
      <div className={`modern-sidebar${isSidebarVisible ? " expanded" : ""}`}>
        <div className="sidebar-top">
          <div className="sidebar-header">
            {isSidebarVisible ? (
              <GoSidebarCollapse
                className="sidebar-toggle"
                onClick={() => setIsSidebarVisible(false)}
              />
            ) : (
              <GoSidebarExpand
                className="sidebar-toggle"
                onClick={() => setIsSidebarVisible(true)}
              />
            )}
            {isSidebarVisible && <span className="sidebar-title">Priori</span>}
          </div>
          <div className="sidebar-section">
            <ul>
              {navItems.map((item) => (
                <li key={item.label} className="sidebar-item" data-tooltip={item.label} onClick={() => handleNavItemClick(item)}>
                  <span className="sidebar-icon">{item.icon}</span>
                  {isSidebarVisible && <span>{item.label}</span>}
                </li>
              ))}
            </ul>
          </div>
          <div className="sidebar-divider"></div>
          <div className="sidebar-section">
            {isSidebarVisible && <div className="sidebar-section-label">EXPLORE</div>}
            <ul>
              {analysisItems.map((item) => (
                <li key={item.label} className="sidebar-item" data-tooltip={item.label} onClick={() => handleNavItemClick(item)}>
                  <span className="sidebar-icon">{item.icon}</span>
                  {isSidebarVisible && <span>{item.label}</span>}
                </li>
              ))}
            </ul>
          </div>
          <div className="sidebar-divider"></div>
          <div className="sidebar-section">
            {isSidebarVisible && <div className="sidebar-section-label">SETTINGS</div>}
            <ul>
              {accountItems.map((item) => (
                <li key={item.label} className="sidebar-item" data-tooltip={item.label} onClick={() => handleNavItemClick(item)}>
                  <span className="sidebar-icon">{item.icon}</span>
                  {isSidebarVisible && <span className="sidebar-label">{item.label}</span>}
                  {item.badge && (
                    <span className="sidebar-badge">{item.badge}</span>
                  )}
                </li>
              ))}
            </ul>
          </div>
        </div>
        <div className="sidebar-bottom">
          {isAuthenticated && user ? (
            <div className="sidebar-user-section" ref={menuRef}>
              <div className="sidebar-user-profile" onClick={handleUserMenuClick}>
                <div className="sidebar-user-avatar">
                  <div className="user-avatar">
                    {(user.name || user.email || 'U').charAt(0).toUpperCase()}
                  </div>
                </div>
                {isSidebarVisible && (
                  <div className="sidebar-user-info">
                    <div className="sidebar-user-name">{username || user?.name || user?.email?.split('@')[0]}</div>
                    <div className="sidebar-user-plan">Free plan</div>
                  </div>
                )}
              </div>
              {showUserMenu && (
                <div className="user-dropdown-menu">
                  <div className="user-menu-header">
                    <div className="user-plan-section">
                      <div className="user-plan-avatar">
                        <div className="user-avatar">
                          {(user.name || user.email || 'U').charAt(0).toUpperCase()}
                        </div>
                      </div>
                      <div className="user-plan-info">
                        <div className="user-plan-name">{user.email}</div>
                        <div className="user-plan-type">Free plan</div>
                      </div>
                    </div>
                  </div>
                  <div className="user-menu-items">
                    {userMenuItems.map((item, index) => (
                      <div 
                        key={index} 
                        className="user-menu-item"
                        onClick={() => handleMenuItemClick(item)}
                      >
                        <span className="user-menu-label">{item.label}</span>
                      </div>
                    ))}
                  </div>
                  <div className="user-menu-footer">
                    <div className="user-menu-item logout-item" onClick={handleLogoutClick}>
                      <span className="user-menu-label">Log out</span>
                    </div>
                  </div>
                </div>
              )}
            </div>
          ) : (
            <div className="sidebar-signin">
              {isSidebarVisible ? (
                <button className="signin-button" onClick={handleSignInClick}>Sign In</button>
              ) : (
                <div className="sidebar-signin-icon" onClick={handleSignInClick}>
                  <RiLoginCircleFill className="signin-icon" />
                </div>
              )}
              {!isSidebarVisible && <span className="signin-text">Sign In</span>}
            </div>
          )}
        </div>
      </div>
      {/* Blur overlay for mobile, only when sidebar is open */}
      {isSidebarVisible && (
        <div className="sidebar-blur-overlay show" onClick={() => setIsSidebarVisible(false)}></div>
      )}
    </>
  );
};

export default Sidebar;
